import { HOVER_CURSOR_PATH } from '@/game/GameComponents/Utils/GameSpriteAssetsMap';

/* START OF COMPILED CODE */

import UIBlocker from "../GeneralUI/UIBlocker";
/* START-USER-IMPORTS */
import { DailyType } from '@/common/types/game';
import { EventBus } from '@/game/GameComponents/PhaserGame/EventBus';
import { getStudent } from '@/game/GameComponents/PhaserGame/GameInstance';
import EventsManager from '@/game/GameComponents/PhaserGame/Managers/EventsManager';
import { ResponsivenessManager } from '@/game/GameComponents/PhaserGame/Managers/ResponsivenessManager';
import { PhaserAudioManager } from '@/game/GameComponents/PhaserGame/Utils/PhaserAudioManager';
import { GridLayoutGroup } from '@/game/GameComponents/PhaserGame/Utils/PhaserLayout/GridLayoutGroup';
import { getAnchorPlugin } from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';
import GAME_EVENTS from '@/game/GameComponents/PhaserGame/Utils/gameEventsDef';
import DailyActivityUI from '@/game/prefabs/DailyActivities/DailyActivityUI';
import DefaultButton from '@/game/prefabs/GeneralUI/Buttons/DefaultButton';
/* END-USER-IMPORTS */

export default class DailiesPanel extends Phaser.GameObjects.Container {

	constructor(scene: Phaser.Scene, x?: number, y?: number) {
		super(scene, x ?? 0, y ?? 0);

		// uIBlocker
		const uIBlocker = new UIBlocker(scene, 0, 0);
		this.add(uIBlocker);

		// mobileView
		const mobileView = scene.add.container(0, 0);
		this.add(mobileView);

		// mainContainer_m
		const mainContainer_m = scene.add.container(336, 188);
		mobileView.add(mainContainer_m);

		// mainContainerBg_m
		const mainContainerBg_m = scene.add.nineslice(0, 0, "Hud1", undefined, 200, 156, 10, 10, 10, 10);
		mainContainerBg_m.scaleX = 2;
		mainContainerBg_m.scaleY = 2;
		mainContainer_m.add(mainContainerBg_m);

		// totalProgressContainer_m
		const totalProgressContainer_m = scene.add.container(0, 74);
		mainContainer_m.add(totalProgressContainer_m);

		// rubiesBacking_m
		const rubiesBacking_m = scene.add.nineslice(-28, 52, "backingFadeOut_m", undefined, 40, 16, 1, 3, 1, 1);
		rubiesBacking_m.scaleX = 2;
		rubiesBacking_m.scaleY = 2;
		rubiesBacking_m.setOrigin(0, 0.5);
		totalProgressContainer_m.add(rubiesBacking_m);

		// progressBacking_m
		const progressBacking_m = scene.add.image(-136, 16, "placeholder-square");
		progressBacking_m.scaleY = 0.25;
		progressBacking_m.setOrigin(0, 0.5);
		progressBacking_m.visible = false;
		progressBacking_m.tintTopLeft = 4864576;
		progressBacking_m.tintTopRight = 4864576;
		progressBacking_m.tintBottomLeft = 4864576;
		progressBacking_m.tintBottomRight = 4864576;
		totalProgressContainer_m.add(progressBacking_m);

		// progressFill_m
		const progressFill_m = scene.add.image(-136, 16, "placeholder-square");
		progressFill_m.scaleY = 0.25;
		progressFill_m.setOrigin(0, 0.5);
		progressFill_m.visible = false;
		progressFill_m.tintTopLeft = 5537380;
		progressFill_m.tintTopRight = 5537380;
		progressFill_m.tintBottomLeft = 5537380;
		progressFill_m.tintBottomRight = 5537380;
		totalProgressContainer_m.add(progressFill_m);

		// rubiesIcon_m
		const rubiesIcon_m = scene.add.image(-28, 52, "hud-icons", 95);
		rubiesIcon_m.scaleX = 2;
		rubiesIcon_m.scaleY = 2;
		totalProgressContainer_m.add(rubiesIcon_m);

		// finalRewardValue_m
		const finalRewardValue_m = scene.add.bitmapText(-4, 52, "Aronui", "50");
		finalRewardValue_m.setOrigin(0, 0.5);
		finalRewardValue_m.tintTopLeft = 15130076;
		finalRewardValue_m.tintTopRight = 15130076;
		finalRewardValue_m.tintBottomLeft = 15130076;
		finalRewardValue_m.tintBottomRight = 15130076;
		finalRewardValue_m.text = "50";
		finalRewardValue_m.fontSize = -24;
		totalProgressContainer_m.add(finalRewardValue_m);

		// allCompletedText_m
		const allCompletedText_m = scene.add.bitmapText(-32, 20, "Aronui", "All Completed");
		allCompletedText_m.setOrigin(0, 0.5);
		allCompletedText_m.tintTopLeft = 5387071;
		allCompletedText_m.tintTopRight = 5387071;
		allCompletedText_m.tintBottomLeft = 5387071;
		allCompletedText_m.tintBottomRight = 5387071;
		allCompletedText_m.text = "All Completed";
		allCompletedText_m.fontSize = -22;
		totalProgressContainer_m.add(allCompletedText_m);

		// allCompletedCheckbox_m
		const allCompletedCheckbox_m = scene.add.image(-52, 20, "8check05");
		allCompletedCheckbox_m.scaleX = 4;
		allCompletedCheckbox_m.scaleY = 4;
		totalProgressContainer_m.add(allCompletedCheckbox_m);

		// dailiesContainer_m
		const dailiesContainer_m = scene.add.container(-156, -92);
		mainContainer_m.add(dailiesContainer_m);

		// closeButtonContainer_m
		const closeButtonContainer_m = scene.add.container(200, -156);
		mainContainer_m.add(closeButtonContainer_m);

		// closeButton_m
		const closeButton_m = scene.add.image(-24, 24, "hud-icons", 245);
		closeButton_m.scaleX = 2;
		closeButton_m.scaleY = 2;
		closeButtonContainer_m.add(closeButton_m);

		// headerContainer_m
		const headerContainer_m = scene.add.container(0, -152);
		mainContainer_m.add(headerContainer_m);

		// headerBacking_1
		const headerBacking_1 = scene.add.nineslice(0, 0, "Hud2", undefined, 112, 22, 4, 4, 4, 8);
		headerBacking_1.scaleX = 2;
		headerBacking_1.scaleY = 2;
		headerContainer_m.add(headerBacking_1);

		// bitmaptext
		const bitmaptext = scene.add.bitmapText(0, 0, "Aronui", "Daily Activities");
		bitmaptext.setOrigin(0.5, 0.5);
		bitmaptext.tintTopLeft = 985612;
		bitmaptext.tintTopRight = 985612;
		bitmaptext.tintBottomLeft = 985612;
		bitmaptext.tintBottomRight = 985612;
		bitmaptext.text = "Daily Activities";
		bitmaptext.fontSize = -24;
		headerContainer_m.add(bitmaptext);

		// desktopView
		const desktopView = scene.add.container(0, 0);
		desktopView.visible = false;
		this.add(desktopView);

		// mainContainer
		const mainContainer = scene.add.container(512, 384);
		desktopView.add(mainContainer);

		// mainContainerBg
		const mainContainerBg = scene.add.nineslice(0, 0, "Hud1", undefined, 132, 80, 8, 8, 8, 8);
		mainContainerBg.scaleX = 4;
		mainContainerBg.scaleY = 4;
		mainContainer.add(mainContainerBg);

		// header
		const header = scene.add.container(0, -156);
		mainContainer.add(header);

		// headerBacking
		const headerBacking = scene.add.nineslice(0, 0, "Hud2", undefined, 64, 16, 4, 4, 4, 8);
		headerBacking.scaleX = 4;
		headerBacking.scaleY = 4;
		header.add(headerBacking);

		// bitmaptext_3
		const bitmaptext_3 = scene.add.bitmapText(0, 0, "Aronui", "Daily Activities");
		bitmaptext_3.setOrigin(0.5, 0.5);
		bitmaptext_3.tintTopLeft = 985612;
		bitmaptext_3.tintTopRight = 985612;
		bitmaptext_3.tintBottomLeft = 985612;
		bitmaptext_3.tintBottomRight = 985612;
		bitmaptext_3.text = "Daily Activities";
		bitmaptext_3.fontSize = -24;
		header.add(bitmaptext_3);

		// totalProgressContainer
		const totalProgressContainer = scene.add.container(0, 60);
		mainContainer.add(totalProgressContainer);

		// rubiesBacking
		const rubiesBacking = scene.add.nineslice(-28, 52, "1x1sprite", undefined, 64, 28, 10, 10, 10, 10);
		rubiesBacking.setOrigin(0, 0.5);
		rubiesBacking.tint = 4864576;
		totalProgressContainer.add(rubiesBacking);

		// progressBacking
		const progressBacking = scene.add.image(-136, 16, "placeholder-square");
		progressBacking.scaleY = 0.25;
		progressBacking.setOrigin(0, 0.5);
		progressBacking.visible = false;
		progressBacking.tintTopLeft = 4864576;
		progressBacking.tintTopRight = 4864576;
		progressBacking.tintBottomLeft = 4864576;
		progressBacking.tintBottomRight = 4864576;
		totalProgressContainer.add(progressBacking);

		// progressFill
		const progressFill = scene.add.image(-136, 16, "placeholder-square");
		progressFill.scaleY = 0.25;
		progressFill.setOrigin(0, 0.5);
		progressFill.visible = false;
		progressFill.tintTopLeft = 5537380;
		progressFill.tintTopRight = 5537380;
		progressFill.tintBottomLeft = 5537380;
		progressFill.tintBottomRight = 5537380;
		totalProgressContainer.add(progressFill);

		// rubiesIcon
		const rubiesIcon = scene.add.image(-28, 52, "ruby-small");
		rubiesIcon.scaleX = 4;
		rubiesIcon.scaleY = 4;
		totalProgressContainer.add(rubiesIcon);

		// finalRewardValue
		const finalRewardValue = scene.add.bitmapText(-4, 52, "Aronui", "50");
		finalRewardValue.setOrigin(0, 0.5);
		finalRewardValue.tintTopLeft = 15130076;
		finalRewardValue.tintTopRight = 15130076;
		finalRewardValue.tintBottomLeft = 15130076;
		finalRewardValue.tintBottomRight = 15130076;
		finalRewardValue.text = "50";
		finalRewardValue.fontSize = -32;
		totalProgressContainer.add(finalRewardValue);

		// allCompletedText
		const allCompletedText = scene.add.bitmapText(-32, 20, "Aronui", "All Completed");
		allCompletedText.setOrigin(0, 0.5);
		allCompletedText.tintTopLeft = 5387071;
		allCompletedText.tintTopRight = 5387071;
		allCompletedText.tintBottomLeft = 5387071;
		allCompletedText.tintBottomRight = 5387071;
		allCompletedText.text = "All Completed";
		allCompletedText.fontSize = -22;
		totalProgressContainer.add(allCompletedText);

		// allCompletedCheckbox
		const allCompletedCheckbox = scene.add.image(-52, 20, "8check05");
		allCompletedCheckbox.scaleX = 4;
		allCompletedCheckbox.scaleY = 4;
		totalProgressContainer.add(allCompletedCheckbox);

		// dailiesContainer
		const dailiesContainer = scene.add.container(-160, -80);
		mainContainer.add(dailiesContainer);

		// closeButtonContainer
		const closeButtonContainer = scene.add.container(264, -160);
		closeButtonContainer.scaleX = 2;
		closeButtonContainer.scaleY = 2;
		mainContainer.add(closeButtonContainer);

		// closeButton
		const closeButton = scene.add.image(-24, 24, "hud-icons", 245);
		closeButton.scaleX = 2;
		closeButton.scaleY = 2;
		closeButtonContainer.add(closeButton);

		this.progressFill_m = progressFill_m;
		this.finalRewardValue_m = finalRewardValue_m;
		this.allCompletedCheckbox_m = allCompletedCheckbox_m;
		this.dailiesContainer_m = dailiesContainer_m;
		this.closeButton_m = closeButton_m;
		this.mainContainer_m = mainContainer_m;
		this.mobileView = mobileView;
		this.progressBacking = progressBacking;
		this.progressFill = progressFill;
		this.finalRewardValue = finalRewardValue;
		this.allCompletedCheckbox = allCompletedCheckbox;
		this.dailiesContainer = dailiesContainer;
		this.closeButton = closeButton;
		this.mainContainer = mainContainer;
		this.desktopView = desktopView;
		// awake handler
		this.scene.events.once("scene-awake", () => this.awake());

		/* START-USER-CTR-CODE */
    this.activityUIs = [];
    this.setVisible(false);
    /* END-USER-CTR-CODE */
	}

	public progressFill_m: Phaser.GameObjects.Image;
	public finalRewardValue_m: Phaser.GameObjects.BitmapText;
	public allCompletedCheckbox_m: Phaser.GameObjects.Image;
	public dailiesContainer_m: Phaser.GameObjects.Container;
	public closeButton_m: Phaser.GameObjects.Image;
	private mainContainer_m: Phaser.GameObjects.Container;
	public mobileView: Phaser.GameObjects.Container;
	private progressBacking: Phaser.GameObjects.Image;
	public progressFill: Phaser.GameObjects.Image;
	public finalRewardValue: Phaser.GameObjects.BitmapText;
	public allCompletedCheckbox: Phaser.GameObjects.Image;
	public dailiesContainer: Phaser.GameObjects.Container;
	public closeButton: Phaser.GameObjects.Image;
	private mainContainer: Phaser.GameObjects.Container;
	public desktopView: Phaser.GameObjects.Container;

	/* START-USER-CODE */
  activityUIs: DailyActivityUI[];
  mentorDialogueSFX?: Phaser.Sound.BaseSound;
  gridLayoutGroups: GridLayoutGroup[] = [];

  awake() {
    // Setup interactions.
    this.getResponsiveElements('closeButton').forEach(
      (closeButton: DefaultButton) => {
        closeButton.setInteractive({ cursor: `${HOVER_CURSOR_PATH}, auto` });
        closeButton.on('pointerover', () => {
          closeButton.setScale(2.2);
          PhaserAudioManager.playSFX(this.scene, 'hover-click');
        });
        closeButton.on('pointerout', () => {
          closeButton.setScale(2);
        });
        closeButton.on('pointerdown', () => {
          this.close();
        });
      },
    );
    this.refresh();

    this.getResponsiveElements('dailiesContainer').forEach(
      (dailiesContainer: Phaser.GameObjects.Container) => {
        const newLayoutGroup = new GridLayoutGroup({
          scene: this.scene,
          elements: this.activityUIs,
          columns: 1,
          vPadding: 72,
          hPadding: 10,
        });
        this.gridLayoutGroups.push(newLayoutGroup);
        dailiesContainer.add(newLayoutGroup);
      },
    );

    this.initializeResponsiveness();

    EventsManager.registerEventOn(
      this.scene,
      GAME_EVENTS.FINISHED_FEEDBACK_FOR_ALL_DAILY_REWARDS,
      this.handleAllDailiesFeedbackFinished,
      this,
    );
  }

  getResponsiveElements(key: keyof DailiesPanel) {
    return ResponsivenessManager.GetAllResponsiveComponentsFromContainer<DailiesPanel>(
      this,
      key,
    );
  }

  open() {
    this.setVisible(true);
    this.refresh();
    this.playMentorDailyAudio();
    PhaserAudioManager.playSFX(this.scene, 'npc_dialogue_open');
    EventBus.emit(GAME_EVENTS.DAILY_PANEL_OPENED);
  }

  close() {
    PhaserAudioManager.playSFX(this.scene, 'panel-close');
    this.setVisible(false);
    this.mentorDialogueSFX?.stop();
    EventBus.emit(GAME_EVENTS.DAILY_PANEL_CLOSED);
  }

  refresh() {
    const dailies = getStudent().dailyActivities;

    // Generate daily activities.
    this.gridLayoutGroups.forEach((group) => group.clear());
    this.activityUIs = [];

    // Minigames daily.
    this.gridLayoutGroups.forEach((group) => {
      const minigameDaily = new DailyActivityUI(this.scene, 0, 0);
      minigameDaily.setDailyActivity(DailyType.MINIGAME);
      this.activityUIs.push(minigameDaily);
      group.addItem(minigameDaily);
    });

    // Duel daily.
    if (dailies.duel.shouldCompleteDuel) {
      this.gridLayoutGroups.forEach((group) => {
        const duelDaily = new DailyActivityUI(this.scene, 0, 0);
        duelDaily.setDailyActivity(DailyType.DUEL);
        this.activityUIs.push(duelDaily);
        group.addItem(duelDaily);
      });
    }

    // Set progress bar
    const maxProgressScale = this.progressBacking.scaleX;

    const numTotalDailies = this.numTotalDailies();
    const numCompletedDailies = this.numCompletedDailies();
    const progress = numCompletedDailies / numTotalDailies;
    this.getResponsiveElements('progressFill').forEach(
      (progressFill: Phaser.GameObjects.Image) => {
        progressFill.setScale(
          progress * maxProgressScale,
          this.progressFill.scaleY,
        );
      },
    );

    // Final reward
    this.getResponsiveElements('finalRewardValue').forEach(
      (finalRewardValue: Phaser.GameObjects.BitmapText) => {
        finalRewardValue.setAlpha(progress >= 1 ? 0.5 : 1);
      },
    );

    this.getResponsiveElements('allCompletedCheckbox').forEach(
      (allCompletedCheckbox: Phaser.GameObjects.Image) => {
        allCompletedCheckbox.setTexture(
          progress >= 1 ? '8check06' : '8check05',
        );
      },
    );
  }

  numTotalDailies = () => {
    const dailies = getStudent().dailyActivities;
    const { shouldCompleteDuel } = dailies.duel;
    return dailies.minigames.targetNumMinigames + (shouldCompleteDuel ? 1 : 0);
  };

  numCompletedDailies = () => {
    const dailies = getStudent().dailyActivities;
    return (
      dailies.minigames.numCompletedMinigames +
      (dailies.duel.hasCompletedDuel ? 1 : 0)
    );
  };

  playMentorDailyAudio() {
    // Disable this for now.
    // const ssLevel = getStudent().level;
    // const allDailiesComplete =
    //   this.numCompletedDailies() >= this.numTotalDailies();
    // const suffix = allDailiesComplete
    //   ? '-dailies-complete'
    //   : '-dailies-available';
    // const soundKey = `${
    //   MentorPrefixes[getBiomeFromStudentLevel(ssLevel)]
    // }${suffix}`;
    // this.mentorDialogueSFX = this.scene.sound.get(soundKey);
    // if (!this.mentorDialogueSFX) {
    //   this.mentorDialogueSFX = this.scene.sound.add(soundKey);
    // }
    // this.mentorDialogueSFX.play();
  }

  initializeResponsiveness() {
    // Setup breakpoints.
    ResponsivenessManager.InitializeResponsiveBreakpoints({
      scene: this.scene,
      desktopView: this.desktopView,
      mobileView: this.mobileView,
    });
    // Responsiveness.
    const anchor = getAnchorPlugin(this.scene);
    anchor.add(this, {
      top: '0%',
      left: '0%',
    });
    anchor.add(this.mainContainer, {
      centerX: '50%',
      centerY: '50%',
    });
    anchor.add(this.mainContainer_m, {
      centerX: '50%',
      centerY: '50%',
    });
    ResponsivenessManager.MakeElementScaleDownWithGameSize(this.mainContainer);
  }

  handleAllDailiesFeedbackFinished() {
    this.open();
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
